import { render } from "./chatApp.vue?vue&type=template&id=a1553cf4"
import script from "./chatApp.vue?vue&type=script&lang=js"
export * from "./chatApp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__